var pinyin={
    sortCity(a,b){
        return b.city.localeCompare(a.city);
    },
    pySegSort(arr,empty) {
      if(!String.prototype.localeCompare)
        return null;
      var letters = "#ABCDEFGHIJKLMNOPQRSTUVWXYZ".split('');
      var segs = [];
      var curr;
      letters.forEach((letter)=>{
        curr = {letter: letter, data:[]};
        arr.forEach((item)=>{
          if(item.cityCode.substr(0,1).toUpperCase()==letter){
            curr.data.push(item);
          }
        })
        if(empty || curr.data.length) {
          segs.push(curr);
          curr.data.sort(this.sortCity);
        }
      })
      return segs;
    },
    searchResult(arr,key){
        var res=[];
        arr.forEach((item)=>{
          if(item.city.indexOf(key)>-1||item.cityCode.indexOf(key)>-1){
            res.push(item)
          }
        })
        return res;
    }
}
export default pinyin;


// WEBPACK FOOTER //
// ./src/store/pinyin.js